import React from 'react';
import styled from 'styled-components';

// Eye Open Icon
export const EyeOpenIcon = styled(({ disabled, color, ...rest }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M1.5 12C1.5 12 5 7 12 7C19 7 22.5 12 22.5 12C22.5 12 19 17 12 17C5 17 1.5 12 1.5 12Z" stroke={color || 'black'} strokeWidth="2"/>
    <circle cx="12" cy="12" r="3" stroke={color || 'black'} strokeWidth="2"/>
  </svg>
))`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

// Eye Closed Icon
export const LockIcon = styled(({ disabled, color, ...rest }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M6 10V7C6 4.79 7.79 3 10 3H14C16.21 3 18 4.79 18 7V10M12 17V14M21 10H3V21H21V10Z" stroke={color || 'black'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
))`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;
